import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Clipboard16, ClipboardCheck16, Clock16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant, Modal } from '@makyoapp/makyo-ui'

import { formatError } from '@/lib/error'

export function ErrorFallbackModal({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const { message, status } = formatError(error)

  const handleReload = () => {
    window.location.reload()
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(error?.stack || '')
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <Modal show={true} onHide={resetErrorBoundary} id='error-fallback-modal' className='bg-zinc-200 dark:bg-slate-900'>
      <Modal.Header>{t('Oooppsss...')}</Modal.Header>

      <Modal.Body className='modal-md max-w-full'>
        <p>{t('An unexpected error occurred')}</p>

        <p className='mt-2 font-mono bg-zinc-200 dark:bg-slate-900 py-2 px-4 rounded'>
          {status}: {message}
        </p>

        <details style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }} className='relative'>
          <pre className='overflow-x-auto bg-zinc-200 dark:bg-slate-900 p-4 rounded relative'>{error?.stack}</pre>
        </details>
      </Modal.Body>

      <Modal.Footer className='py-6 justify-between'>
        <Button
          onClick={handleCopy}
          variant={ButtonVariant.Outlined}
          icon={copied ? <ClipboardCheck16 /> : <Clipboard16 />}
        >
          {copied ? t('Copied') : t('Copy')}
        </Button>

        <Button onClick={handleReload} icon={<Clock16 />}>
          {t('Reload Page')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
